import { useMutation } from "@tanstack/react-query";
import { useOrderService } from "contexts/ServiceContext";
import useRefetchOrders from "hooks/useRefetchOrders";
import OrderService from "../../../services/OrderService";
import { ORDERS_QUERY_KEY } from "./useOrders";
import { BrokenRuleValidationError } from "services/apiErrors";

type UpdateOrderValues = Omit<
  Parameters<OrderService["updateOrderLineItem"]>[2],
  "cardCode"
> & {
  docEntry: number;
  isDraft: boolean;
};

const useUpdateOrder = (customerCode: string) => {
  const orderService = useOrderService();
  const refetchOrders = useRefetchOrders();

  return useMutation<
    Record<string, any>,
    BrokenRuleValidationError | Error,
    UpdateOrderValues
  >({
    mutationKey: [ORDERS_QUERY_KEY, "patch", { customerCode }],
    mutationFn: (data: UpdateOrderValues) => {
      return data.docEntry
        ? orderService.updateOrderLineItem(data.docEntry, data.isDraft, {
            shipTo: data.shipTo,
            poNumber: data.poNumber,
            cardCode: customerCode,
          })
        : Promise.reject();
    },
    onSuccess: async (data) => refetchOrders(data.order.contractNumber),
  });
};

export default useUpdateOrder;
